// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyC0mLLm4KQWGAlmxPfTrKH1RIPhjr4PHek",
  authDomain: "operationborderlights.firebaseapp.com",
  projectId: "operationborderlights",
  storageBucket: "operationborderlights.firebasestorage.app", // note: differs from .appspot.com
  messagingSenderId: "828764576930",
  appId: "1:828764576930:web:f707fd2182b4a3b4ad4bfb",
  measurementId: "G-JRLDEPQ3FE",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
